module.exports = __webpack_public_path__ + "48ca875e772a7ed292542e250f0bf738.MP3";